// extracted by mini-css-extract-plugin
export default {"PageInformationFacturation":"PageInformationsFacturation_PageInformationFacturation__GKVcy","Formulaire":"PageInformationsFacturation_Formulaire__gAroz"};